// removed by extract-text-webpack-plugin
module.exports = {"List":"_2xu4n8el1qs7WwX7RBjuTN","Header":"_2WTRXabfBQcAxeVa7rgwvV","green":"jjwk44cEfBOWfWfs_T-7L","red":"nx5F0tIbAERS-KlrtBCh7","Row":"_2QsGA7L34taY2tybHu2ZBJ"};


//////////////////
// WEBPACK FOOTER
// ./src/lists/ManagersList/index.css
// module id = 956
// module chunks = 0